/** Import local dependencies */
import Transitions from "./components/transitions";
import Parallax from "./components/parallax";
import Modals from './components/modals.js';
import Share from './components/share.js';
import Accordion from './components/accordion.js';
import Navigation from './components/navigation.js';
import Header from './components/header.js';
import Toc from './components/toc.js';
import GTM from './components/gtm.js';
import Cookies from './components/cookies.js';
import BaseLesson from "./components/base-lesson";
import Swiper from "./components/swiper";
import Test from "./components/test";

/** Initialise local dependencies */
Modals.init();
Share.init();
Accordion.init();
Navigation.init();
Header.init();
Toc.init();
GTM.init();
Cookies.init();
BaseLesson.init();
Swiper.init();
Test.init();

if (document.body.classList.contains( 'page-animation' )) {
  Transitions.init();
  Parallax.init();
}
